import React from 'react';
import { useTypedSelector } from "../../redux/hooks";
import { selectCurrentUserId } from "../../redux/slices";
import Icon, { IconName } from "../Icon";
import { usePolyglot } from "../../context/Polyglot";
import { selectConversationOtherMemberTimes } from '../../redux/slices/chatNSlice';

export const ConvoMessageStatusIcon: React.FC<{ time: string, from: string, conversation_uuid: string }> = ({ time, from, conversation_uuid }) => {
    const userUuid = useTypedSelector(selectCurrentUserId);
    const { minReadAt, minDeliveredAt } = useTypedSelector(state => selectConversationOtherMemberTimes(state, conversation_uuid, userUuid));

    const { t } = usePolyglot();

    if (from !== userUuid) return null;

    let iconName: IconName;
    let status: string;
    let isRead: boolean;

    if (minReadAt !== null && minReadAt.localeCompare(time) >= 0) {
        iconName = "doubleTick";
        status = t("phrases.message_read");
        isRead = true;
    } else if (minDeliveredAt !== null && minDeliveredAt.localeCompare(time) >= 0) {
        iconName = "doubleTick";
        status = t("phrases.message_delivered");
        isRead = false;
    } else {
        iconName = "singleTick";
        status = t("phrases.message_sent");
        isRead = false;
    }

    return (
        <span title={status} data-is-read={isRead ? 'true' : 'false'}>
            <Icon name={iconName} width={28} height={28} ariaHidden def />
        </span>
    )
};
